import { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../App.css";
import PrimerGrado from "../img/primergrado.png";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ModalForm from "../components/ModalForm";
import ModalDownload from "../components/ModalDownload";
import OptionButton from "../components/OptionButton";
import Cookies from "js-cookie";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";

function App() {
  const [showForm, setShowForm] = useState(false);
  const [showDownload, setShowDownload] = useState(false);
  const [formComplete, setFormComplete] = useState(
    Cookies.get("form-complete")
  );
  const [currentHref, setCurrentHref] = useState(null);
  const [currentDownloadResource, setCurrentDownloadResource] = useState(null);
  const [currentImage, setCurrentImage] = useState(null);

  const handleCloseForm = (href, downloadResource, image, validated) => {
    setShowForm(false);
    if (validated) {
      setCurrentHref(href);
      setCurrentDownloadResource(downloadResource);
      setCurrentImage(image);
      setShowDownload(true);
      Cookies.set("form-complete", true);
      setFormComplete(true);
    }
  };
  const handleCloseDownload = () => setShowDownload(false);
  const openModalForm = (href, resource, image) => {
    setCurrentHref(href);
    setCurrentDownloadResource(resource);
    setCurrentImage(image);
    setShowForm(true);
  };
  return (
    <div className="App">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Libros Nuestro País: Primer grado</title>
        <meta property="og:title" content="Libros Nuestro País: Primer grado" />
        <meta
          name="description"
          content="Estos materiales didácticos, elaborados por el IEP, en alianza con la Fundación Mohme y el Jurado Nacional de Elecciones, son parte del “Proyecto Democracia: construyendo ciudadanía desde la escuela”."
        ></meta>
        <meta
          property="og:url"
          content={process.env.REACT_APP_URL + "primer-grado"}
        />
      </Helmet>
      <header className="header d-flex align-items-center p-2">
        <Container>
          <div className="navbar-top d-flex justify-content-end">
            <Navbar />
          </div>
          <Row className="align-items-center mt-5">
            <Col md={8} xs={12}>
              <h1>Nuestro País: Primer grado</h1>
              <p className="mt-5 mb-2">
                Esta colección ha sido puesta a disposición del Ministerio de
                Educación del Perú (MINEDU) para su uso en todas las
                instituciones educativas de nuestro país. Los pedagogos del
                MINEDU han trabajado en base a este material y han adaptado
                nuestros libros para crear la serie Nuestro País para toda la
                primaria. Desde el año 2020, forma parte del paquete básico de
                recursos educativos que todos los estudiantes del Perú reciben.
              </p>
              <p>
                {" "}
                En esta oportunidad, con la finalidad de colaborar con la
                educación a distancia y hacer más amigable el uso de nuestros
                libros, los compartimos en un nuevo formato. Hemos elaborado
                fichas para que docentes y familias puedan acceder a ellas y
                puedan descargarlas, imprimirlas, socializarla con los
                estudiantes. La motivación más grande para la creación de este
                material es la preocupación por complementar la educación de
                niños y niñas que, a pesar de las difíciles circunstancias,
                tienen derecho a aprender.
              </p>
              <div className="mb-2">
                <Button variant="outline-primary" href="#fichas">
                  Descargar fichas
                </Button>
              </div>
            </Col>
            <Col md={4} xs={12}>
              <img
                src={PrimerGrado}
                alt="Estudiantes"
                className="img-fluid mt-5"
              />
            </Col>
          </Row>
        </Container>
      </header>
      <section id="fichas">
        <Container className="my-5 pt-5">
          <Row className="text-center">
            <Col md={4} sm={6} xs={12}>
              <img
                src="https://fundacionmohme.org/wp-content/uploads/2021/05/caratula-primer-grado-pdf-1024x745.jpg"
                alt="Ficha"
                width="240"
              />
              <h5 className="mt-3 mb-3">Caratula</h5>
              <OptionButton
                formComplete={formComplete}
                href="https://fundacionmohme.org/wp-content/uploads/2021/05/caratula-primer-grado.pdf"
                downloadResource="caratula-primer-grado.pdf"
                image="https://fundacionmohme.org/wp-content/uploads/2021/05/caratula-primer-grado-pdf-1024x745.jpg"
                openModalForm={openModalForm}
                className="mb-5"
              />
            </Col>
            <Col md={4} sm={6} xs={12}>
              <img
                src="https://fundacionmohme.org/wp-content/uploads/2021/05/Primer-grado-pdf-1024x745.jpg"
                alt="Ficha"
                width="240"
              />
              <h5 className="mt-3 mb-3">Ficha 1 y 2</h5>
              <OptionButton
                formComplete={formComplete}
                href="https://fundacionmohme.org/wp-content/uploads/2021/05/Primer-grado.pdf"
                downloadResource="Primer-grado.pdf"
                image="https://fundacionmohme.org/wp-content/uploads/2021/05/Primer-grado-pdf-1024x745.jpg"
                openModalForm={openModalForm}
                className="mb-5"
              />
            </Col>
            <Col md={4} sm={6} xs={12}>
              <img
                src="https://fundacionmohme.org/wp-content/uploads/2021/05/Primer-grado-3-pdf-1024x745.jpg"
                alt="Ficha"
                width="240"
              />
              <h5 className="mt-3 mb-3">Ficha 3</h5>
              <OptionButton
                formComplete={formComplete}
                href="https://fundacionmohme.org/wp-content/uploads/2021/05/Primer-grado-3.pdf"
                downloadResource="Primer-grado-3.pdf"
                image="https://fundacionmohme.org/wp-content/uploads/2021/05/Primer-grado-3-pdf-1024x745.jpg"
                openModalForm={openModalForm}
                className="mb-5"
              />
            </Col>
            <Col md={4} sm={6} xs={12}>
              <img
                src="https://fundacionmohme.org/wp-content/uploads/2021/05/Primer-grado-4-pdf-1024x745.jpg"
                alt="Ficha"
                width="240"
              />
              <h5 className="mt-3 mb-3">Ficha 4</h5>
              <OptionButton
                formComplete={formComplete}
                href="https://fundacionmohme.org/wp-content/uploads/2021/05/Primer-grado-4.pdf"
                downloadResource="Primer-grado-4.pdf"
                image="https://fundacionmohme.org/wp-content/uploads/2021/05/Primer-grado-4-pdf-1024x745.jpg"
                openModalForm={openModalForm}
                className="mb-5"
              />
            </Col>
            <Col md={4} sm={6} xs={12}>
              <img
                src="https://fundacionmohme.org/wp-content/uploads/2021/07/Primer-grado-5-pdf-1024x745.jpg"
                alt="Ficha"
                width="240"
              />
              <h5 className="mt-3 mb-3">Ficha 5</h5>
              <OptionButton
                formComplete={formComplete}
                href="https://fundacionmohme.org/wp-content/uploads/2021/07/Primer-grado-5.pdf"
                downloadResource="Primer-grado-5.pdf"
                image="https://fundacionmohme.org/wp-content/uploads/2021/07/Primer-grado-5-pdf-1024x745.jpg"
                openModalForm={openModalForm}
                className="mb-5"
              />
            </Col>
            <Col md={4} sm={6} xs={12}>
              <img
                src="https://fundacionmohme.org/wp-content/uploads/2021/07/Primer-grado-6-pdf-1024x745.jpg"
                alt="Ficha"
                width="240"
              />
              <h5 className="mt-3 mb-3">Ficha 6</h5>
              <OptionButton
                formComplete={formComplete}
                href="https://fundacionmohme.org/wp-content/uploads/2021/07/Primer-grado-6.pdf"
                downloadResource="Primer-grado-6.pdf"
                image="https://fundacionmohme.org/wp-content/uploads/2021/07/Primer-grado-6-pdf-1024x745.jpg"
                openModalForm={openModalForm}
                className="mb-5"
              />
            </Col>
            <Col md={4} sm={6} xs={12}>
              <img
                src="https://fundacionmohme.org/wp-content/uploads/2021/11/Primer-grado-7-pdf-1024x745.jpg"
                alt="Ficha"
                width="240"
              />
              <h5 className="mt-3 mb-3">Ficha 7</h5>
              <OptionButton
                formComplete={formComplete}
                href="https://fundacionmohme.org/wp-content/uploads/2021/11/Primer-grado-7.pdf"
                downloadResource="Primer-grado-7.pdf"
                image="https://fundacionmohme.org/wp-content/uploads/2021/11/Primer-grado-7-pdf-1024x745.jpg"
                openModalForm={openModalForm}
                className="mb-5"
              />
            </Col>
            <Col md={4} sm={6} xs={12}>
              <img
                src="https://fundacionmohme.org/wp-content/uploads/2021/11/Primer-grado-8-pdf-1024x745.jpg"
                alt="Ficha"
                width="240"
              />
              <h5 className="mt-3 mb-3">Ficha 8</h5>
              <OptionButton
                formComplete={formComplete}
                href="https://fundacionmohme.org/wp-content/uploads/2021/11/Primer-grado-8.pdf"
                downloadResource="Primer-grado-6.pdf"
                image="https://fundacionmohme.org/wp-content/uploads/2021/11/Primer-grado-8-pdf-1024x745.jpg"
                openModalForm={openModalForm}
                className="mb-5"
              />
            </Col>
          </Row>
        </Container>
      </section>

      <Footer />
      <ModalForm
        show={showForm}
        handleClose={handleCloseForm}
        href={currentHref}
        image={currentImage}
        downloadResource={currentDownloadResource}
      />
      <ModalDownload
        show={showDownload}
        handleClose={handleCloseDownload}
        href={currentHref}
        downloadResource={currentDownloadResource}
        image={currentImage}
      />
    </div>
  );
}

export default App;
